import { Component, DestroyRef, inject, OnDestroy } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { BehaviorSubject, filter, ReplaySubject, Subscription, tap } from "rxjs";
import { ISidepanelTab } from "src/app/components/sidepanel-tabs/sidepanel-tabs.component";
import { AccountManagementInvitationModel, AccountManagementUserModel } from "src/app/models/api/accountManagement.model";
import { AccessService } from "src/app/services/infra/access/access.service";
import { AccountService } from "src/app/services/infra/account/account.service";

@Component({
    selector: "app-user-management",
    templateUrl: "./account-management.component.html",
    styleUrls: ["./account-management.component.scss"],
})
export class AccountManagementComponent implements OnDestroy {
    public tabs: ISidepanelTab[] = [{ labelPath: "userManagementPage.tabs.users" }];

    public currentTabIndex = 0;
    public users: AccountManagementUserModel[] = [];
    public invitations: AccountManagementInvitationModel[] = [];

    public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public usersAndInvitationsReadyBehavioralSubject$: ReplaySubject<AccountManagementUserModel[]> = new ReplaySubject<
        AccountManagementUserModel[]
    >();

    private _usersSubscription$?: Subscription;

    private _accountService = inject(AccountService);
    private _accessService = inject(AccessService);
    private _destroyRef = inject(DestroyRef);

    ngOnInit() {
        this._accountService
            .getAccountCategory$()
            .pipe(
                filter((accountCategory) => accountCategory !== null),
                tap((accountCategory) => {
                    if (this._accessService.renderAPITabAndDocsButton(accountCategory)) {
                        this.tabs = [...this.tabs, { labelPath: "userManagementPage.tabs.api" }];
                    }
                }),
                takeUntilDestroyed(this._destroyRef),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this._usersSubscription$?.unsubscribe();
    }

    public onTabSelect(tabIndex: number) {
        this.currentTabIndex = tabIndex;
    }
}
